module.exports = __webpack_public_path__ + "static/media/signature.b2f6ded8.svg";